var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-pie-chart fa-lg icon-button",attrs:{"title":"Rateio"},on:{"click":function($event){$event.stopPropagation();return _vm.detalharItemDespesa()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }